import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Faq from './components/Faq';
import Comments from './components/Comments';
import App from './components/App';
import Updates from './components/Updates';
import Index from './components/Index';
import Features from './components/Features';
import Carousel from './components/Carousel';
import About from './components/About';
import Topics from './components/Topics';
import Media from './components/Media';
import Cards from './components/Cards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Contact />
        <Faq />
        <Comments />
        <App />
        <Updates />
        <Index />
        <Features />
        <Carousel />
        <About />
        <Topics />
        <Media />
        <Cards />
      </main>
      <Footer />
    </>
  );
}